exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fraud-awareness-banner-container {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.fraud-awareness-banner {\n  width: -moz-fit-content;\n  width: fit-content;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  cursor: pointer;\n  position: relative;\n}\n.fraud-awareness-banner svg {\n  max-width: 100%;\n  height: auto;\n}\n.close-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  z-index: 10;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/fraud-awareness-banner/fraud-awareness-banner.component.styl
// module id = ../../../../../src/app/master/dashboard/fraud-awareness-banner/fraud-awareness-banner.component.styl
// module chunks = main